import { Injectable } from "@angular/core";
import { DateRangeParam, UserPreference } from "../../models";
import { appSettings, errorMessages } from "../../settings";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";
import { BlindCountError, WidgetParam } from "../../models/DataModels";

@Injectable()
export class BlindCountErrorService extends BaseService {
  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService,
    private _analyticsService: AnalyticsService
  ) {
    super();
  }

  init(widget: any) {
    widget.dataLoaded = false;

    let param = new WidgetParam();
    let dateParam: DateRangeParam = new DateRangeParam();
    let setting = widget.widgetsettings;
    if(setting.PickType == 'PostShip' || setting.PickType == null || setting.PickType == '') {
      setting.PickType = appSettings.Last2Weeks;
    }
    
    dateParam.RangeValue = this._widgetHelper.GetSummaryType(setting.PickType);
    dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(setting.PickType);

    this._analyticsService.getDates(dateParam).subscribe(data => {
      if (
        data.Start_Date.toString() != "0001-01-01T00:00:00" &&
        data.End_Date.toString() != "0001-01-01T23:59:59.999"
      ) {
        param.StartDate = new Date(data.Start_Date);
        param.EndDate = new Date(data.End_Date);
        let userPref: UserPreference = this._commonService.getUserPreference();
        param.CustomerId = userPref.CustomerId;
        param.FacilityId = userPref.FacilityId;
        
        this.GetBlindCountErrorSummary(widget, param);
      }
    });
  }

  GetBlindCountErrorSummary(widget, param: WidgetParam) {
    let userPref: UserPreference = this._commonService.getUserPreference();
    param.CustomerId = userPref.CustomerId;
    param.FacilityId = userPref.FacilityId;

    this._analyticsService.GetBlindCountErrorSummary(param).subscribe(
      (result: Array<BlindCountError>) => {
        widget.errorMessage = null;
        if (result && result.length > 0) {
          let blindCount = [];
          let xAxisData = [];
          result.forEach(row => {
            let rptdate = null;
            rptdate = row.REPORT_DATE
              ? this._commonService.formatDate(new Date(row.REPORT_DATE),appSettings.chartDayFormat)
              : null;
            if (rptdate && xAxisData.indexOf(rptdate) == -1) {
              blindCount.push(row.BLINDS_COUNT);    
              xAxisData.push(rptdate);
            }
          });

          widget.chartOptions = this.chartOptions();
          this.addDataSeries(widget.chartOptions, blindCount, "", "bar", "1");
          this.addZoomBar(widget.chartOptions);
          widget.chartOptions.xAxis.data = xAxisData;
          widget.chartOptions.xAxis.axisLabel.rotate = 45;
        } else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        widget.dataLoaded = true;
      },
      err => {
        console.log("GetBlindCountErrorSummary", err);
        widget.errorMessage = errorMessages.apiError;
        widget.dataLoaded = true;
      }
    );
  }

  reload(widget: any) {}

  remove(widget: any) {}
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/blind-count-error.service.ts